import { render, staticRenderFns } from "./ImportanceCategory.vue?vue&type=template&id=0f495e4b"
import script from "./ImportanceCategory.vue?vue&type=script&lang=js"
export * from "./ImportanceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports